import * as React from "react";
import {
  MasonryVerticalLayoutRenderer,
  type MasonryVerticalLayoutNode,
} from "@leagueplatform/masonry-renderers";
import { type MasonryEngineNodeRendererProps } from "@leagueplatform/masonry-engine";

export const CarePlansVerticalLayoutRenderer = ({
  nodeData,
  ...rest
}: MasonryEngineNodeRendererProps<MasonryVerticalLayoutNode>) => {
  const sectionProps = rest as unknown as Record<
    string,
    React.ReactElement[] | undefined
  >;
  // `nodeData.sections` only exists on Care Plans' own BE-authored nodes.
  // This renderer overrides the SDK's `verticalLayout`/`default` renderer
  // globally, so any other verticalLayout node in the app (no `sections`
  // field at all) must fall through to the items the engine already
  // computed — not be silently emptied out.
  const items = nodeData?.sections
    ? Object.keys(nodeData.sections).flatMap((key) => sectionProps[key] ?? [])
    : rest.items;

  return (
    <MasonryVerticalLayoutRenderer
      {...rest}
      nodeData={nodeData}
      items={items}
    />
  );
};
